module.exports = __webpack_public_path__ + "static/media/lightsaber_by_radiusss.99e366a3.svg";